import React from 'react';

const cards = [
  {
    icon: '🔭',
    title: 'Our Vision',
    text: 'To be a Christ-centered church that transforms lives, families, and communities through the power of the Holy Spirit — reaching every soul with the love and message of Jesus Christ.',
  },
  {
    icon: '🎯',
    title: 'Our Mission',
    text: 'To preach the undiluted Gospel of Jesus Christ, make disciples of all nations, equip believers for ministry, and demonstrate God\'s kingdom through worship, prayer, and compassionate outreach.',
  },
  {
    icon: '💎',
    title: 'Our Core Values',
    list: [
      { label: 'Faith', desc: 'Trusting God in all things, always.' },
      { label: 'Prayer', desc: 'Seeking God daily — 365 days a year.' },
      { label: 'Community', desc: 'Growing together in love and unity.' },
      { label: 'Excellence', desc: 'Giving God our very best in worship.' },
      { label: 'Outreach', desc: 'Reaching the lost for Christ always.' },
    ],
  },
];

export default function About() {
  return (
    <section
      id="about"
      className="section"
      style={{ background: 'linear-gradient(180deg, var(--bg-deep) 0%, #0a1530 100%)' }}
    >
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Who We Are</span>
          <h2 className="section-title">
            Our <span>Vision, Mission</span>
            <br />& Core Values
          </h2>
          <div className="divider center" />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
          {cards.map((card, i) => (
            <div
              key={i}
              className="card fade-up"
              style={{ padding: '36px 30px' }}
            >
              <div style={{ fontSize: '2.4rem', marginBottom: 16 }}>{card.icon}</div>
              <h3 style={{
                fontFamily: "'Cinzel Decorative', serif",
                fontSize: '1rem', color: 'var(--primary)', marginBottom: 14,
              }}>
                {card.title}
              </h3>
              {card.text && (
                <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: '1.05rem', color: 'var(--text-muted)', lineHeight: 1.75 }}>
                  {card.text}
                </p>
              )}
              {card.list && (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {card.list.map((item, j) => (
                    <li key={j} style={{
                      display: 'flex', gap: 10, alignItems: 'flex-start',
                      marginBottom: 10, fontFamily: "'Crimson Pro', serif", fontSize: '1rem', color: 'var(--text-muted)',
                    }}>
                      <span style={{ color: 'var(--primary)', fontWeight: 700, flexShrink: 0 }}>✦</span>
                      <span><strong style={{ color: '#f0e8d8' }}>{item.label}</strong> — {item.desc}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
